import { render, staticRenderFns } from "./DialogAddGrowth.vue?vue&type=template&id=c2460564"
import script from "./DialogAddGrowth.vue?vue&type=script&lang=js"
export * from "./DialogAddGrowth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports